import React, { useEffect, useState} from 'react'
import styles from './WorkReportingTemplates.module.css'
import {Button, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {Alert, Dialog, FormControl, Grid} from "@mui/material";
import AutocompleteSelect from "../../../components/common/inputs/AutoCompleteSelectInput";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import HookForm from "../../../components/common/HookForm";
import {Controller, useForm} from "react-hook-form";
import axios from "axios";
import Snackbar from "@mui/material/Snackbar";
import LoadingBackdrop from "../../../components/common/LoadingBackdrop";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

interface FormData {
    divisionid: number
    woid: number
    pmid: number
    addressid: number
}
const FindWorkOrder = (params) => {
    const formMethods = useForm<FormData>()
    const { setValue, watch, reset } = formMethods
    const [snackbarOpen, setSnackbarOpen] = React.useState({ open: false, message: '' })
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const [woList, setWoList] = React.useState([])
    const [divisionList, setDivisionList] = React.useState([])
    const [pmNumberList, setPMNumbertList] = React.useState([])
    const [initialLoad, setInitialLoad] = React.useState(0)
    const watchDivision = watch('divisionid', null)
    const watchwoid = watch('woid', null)
    const watchaddressid = watch('addressid', null)
    const watchpmid = watch('pmid')
    const [documentData, setDocumentData] = React.useState(
        {
            woid: null,
            addresslist: [],
            employee: '',
            pmnumberlist: [],
            selecteddivisionid: 0,
            workorderlist: [],
            divisionlist: [],
            wocustomerrelease: "",
            wocustomerworkcode: "",
            wocustomerworkorder: "",
            wostatus: "",
            woaddress: "",
        })

    useEffect(() => {

        if (params.findWorkOrder == true) {
            debugger
            reset({
                woid: null,
                divisionid: null,
                pmid: null,
                addressid: null,
            })
            setDocumentData({
                woid: null,
                addresslist: [],
                employee: '',
                pmnumberlist: [],
                selecteddivisionid: null,
                workorderlist: [],
                divisionlist: [],
                wocustomerrelease: "",
                wocustomerworkcode: "",
                wocustomerworkorder: "",
                wostatus: "",
                woaddress: "",
            })
            // params.setWoid(null)
            getDocumentData(null, null)
        }
    }, [params.findWorkOrder])

    useEffect(() => {
        getData({})
    }, [])

    useEffect(() => {
        if (params.findWorkOrder == true ) {
            debugger
            setDocumentData({
                woid: null,
                addresslist: [],
                employee: '',
                pmnumberlist: [],
                selecteddivisionid: null,
                workorderlist: [],
                divisionlist: [],
                wocustomerrelease: "",
                wocustomerworkcode: "",
                wocustomerworkorder: "",
                wostatus: "",
                woaddress: "",
            })
            params.setWoid(null)

            var woidTemp = null
            if (watchwoid) {
                woidTemp = watchwoid
            }
            else if (watchpmid) {
                woidTemp = watchpmid
            }
            else if (watchaddressid) {
                woidTemp = watchaddressid
            }
            getDocumentData(watchDivision ? watchDivision : null, woidTemp)
        }
    }, [watchwoid, watchpmid, watchaddressid])

    useEffect(() => {
        if (watchDivision > 0 && initialLoad > 0) {
            getDocumentData(watchDivision ? watchDivision : null, null)
        }
        else if (watchDivision > 0) {
            setInitialLoad(initialLoad+1)
        }
    }, [watchDivision])

    const getDocumentData = (divisionid, woid) => {
        if (params.findWorkOrder) {
            var hasIds = false
            var body = {}
            if  (divisionid) {
                hasIds = true
                body['divisionid'] = divisionid
            }
            if  (woid) {
                hasIds = true
                body['woid'] = woid
            }
            if (hasIds) {
                getData(body)
            }
        }
    }

    const getData = (body) => {
        setLoadingBackdrop(true)
        axios.post(`workreportingtemplate`, body).then((response) => {
            const parsedResponse = JSON.parse(response?.data.jsonString)

            if (parsedResponse?.divisionlist?.length > 0) {
                setDivisionList(parsedResponse?.divisionlist.map(item => { return {label: item.division, value: item.divisionid}}))
            }
            if (parsedResponse?.pmnumberlist?.length > 0) {
                setPMNumbertList(parsedResponse?.pmnumberlist.map(item => {
                    return {label: item.info, value: item.woid}
                }))
            }
            if (parsedResponse?.workorderlist?.length > 0) {
                setWoList(parsedResponse?.workorderlist.map(item => {
                    return {label: item.info, value: item.woid}
                }))
            }

            setDocumentData({selecteddivisionid: documentData.selecteddivisionid, workorderlist: documentData.workorderlist, pmnumberlist: documentData.pmnumberlist, addresslist: documentData.addresslist, divisionlist: documentData.divisionlist, ...parsedResponse})
            if (parsedResponse?.selecteddivisionid > 0) {
                setValue('divisionid', parsedResponse?.selecteddivisionid)
            }

            setLoadingBackdrop(false)
        }).catch(error => {
            if (error.response) {
                setSnackbarOpen({ open: true, message: error?.response?.data?.title  });
            } else if (error.request) {
                setSnackbarOpen({ open: true, message: error.request  });
            } else {
                setSnackbarOpen({ open: true, message: error.message  });
            }
            setLoadingBackdrop(false)
        })
    }

    const onSubmit = async () => {
        params.setWoid(documentData?.woid)
        params.setFindWorkOrder(false)
    }

    const getAddressOptions = () => {
        return documentData?.addresslist?.map(item => {
            return {value: item.woid, label: item.info}
        })
        return []
    }

    const getPMOptions = () => {
        return documentData?.pmnumberlist?.map(item => {
            return {value: item.woid, label: item.info}
        })
        return []
    }

    const getDivisionOptions = () => {
        return documentData?.divisionlist?.map(item => {
            return {value: item.divisionid, label: item.division}
        })
        return []
    }

    const getWOOptions = () => {
        return documentData?.workorderlist?.map(item => {
            return {value: item.woid, label: item.info}
        })
        return []
    }

    const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen({ open: false, message: ""  });
    }


    return (
            <Dialog fullWidth={true} open={params.findWorkOrder}>
                <LoadingBackdrop open={loadingBackdrop} />
                <DialogTitle>Find Work Order</DialogTitle>
                <>
                    <Snackbar
                        open={snackbarOpen.open}
                        autoHideDuration={4000}
                        onClose={handleSnackbarClose}
                        anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                    >
                        <Alert severity="success">
                            {snackbarOpen.message}
                        </Alert>
                    </Snackbar>
                </>
                <DialogContent>
                    <HookForm
                        methods={formMethods}
                        onSubmit={onSubmit}
                        className={styles.form}>

                        <FormControl fullWidth>
                            {/*<FormLabel style={{marginBottom: '10px'}} component="legend">Select a division to continue</FormLabel>*/}

                            <AutocompleteSelect
                                name="divisionid"
                                label="Division"
                                options={getDivisionOptions()}
                                required={true}
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <AutocompleteSelect
                                name="woid"
                                label="Work Order"
                                options={getWOOptions()}
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <AutocompleteSelect
                                name="pmid"
                                label="PM Number / Release"
                                options={getPMOptions()}
                            />
                        </FormControl>
                        <FormControl fullWidth>
                            <AutocompleteSelect
                                name="addressid"
                                label="Address"
                                options={getAddressOptions()}
                            />
                        </FormControl>

                        <FormControl fullWidth style={{display: documentData?.woid ? 'block' : 'none'}}>
                            <Box>
                                <Grid
                                    container
                                    border={.5}
                                    direction="row"
                                    alignItems="center"
                                    justifyContent="center"
                                    height={'100%'}
                                    width={'100%'}
                                >
                                    <>
                                        <Grid item border={.25} xl={12} md={12} xs={12}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                width={'100%'}
                                            >
                                                <Typography variant="h5" gutterBottom>
                                                    {'Selected WO # ' + documentData.woid}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item border={0} xl={6} md={6} xs={12}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                                width={'100%'}
                                            >
                                                <Typography variant="subtitle1">
                                                    {'PM # ' + documentData.wocustomerworkorder}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item border={0} xl={6} md={6} xs={12}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                            >
                                                <Typography variant="subtitle1">
                                                    {'Release ' + documentData.wocustomerrelease}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item border={0} xl={6} md={6} xs={12}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                            >
                                                <Typography variant="subtitle1">
                                                    {'Address ' + documentData.woaddress}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item border={0} xl={6} md={6} xs={12}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                            >
                                                <Typography variant="subtitle1">
                                                    {'Material Code: ' + documentData.wocustomerworkcode}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                        <Grid item border={0} xl={6} md={6} xs={12}>
                                            <Box
                                                display="flex"
                                                justifyContent="center"
                                            >
                                                <Typography variant="subtitle1">
                                                    {'Status: ' + documentData.wostatus}
                                                </Typography>
                                            </Box>
                                        </Grid>
                                    </>
                                </Grid>
                            </Box>
                        </FormControl>
                        <DialogActions>
                            <Button onClick={()=> {
                                params.setWoid(null)
                                params.setFindWorkOrder(false)
                            }} variant="contained" style={{width: '100%'}}>
                                Cancel
                            </Button>
                            <Button disabled={watchwoid == null && watchpmid == null && watchaddressid == null} onClick={()=> {onSubmit()}} type="submit" variant="contained" style={{width: '100%'}}>
                                Create
                            </Button>
                        </DialogActions>
                    </HookForm>
                </DialogContent>
            </Dialog>
    )
}
export default FindWorkOrder